var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box } from '@mui/material';
import * as Preact from 'preact';
import { isSmallScreen } from './domain/theme/breakpoints';
import { useTheme } from '@mui/material';
export var Component = function (p) {
    var theme = useTheme();
    return (Preact.h(Box, { sx: __assign({ display: 'flex', width: 'fit-content', alignItems: 'center', justifyContent: 'center', padding: '4px', backgroundColor: 'white.main', gap: isSmallScreen(theme) ? '5px' : '4px', borderRadius: '8px', position: 'absolute', boxShadow: '0px 7px 20px rgba(0, 0, 0, 0.07)', zIndex: 'appBar' }, p.sx) }, p.children));
};
Component.displayName = 'ActionBar';
